/**
 * mini.ts — Categoría "Minimercado / Abarrotes" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_mini",
  skuPrefix: "MIN",
  categoria: "Minimercado",
} as const;

export const cat_mini_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Atén Van Camps en Agua",
    marca: "Van Camps",
    origen: "Colombia",
    costo: 4500,
    precio: 7500,
    stock: 120,
    stockMinimo: 25,
    stockMaximo: 240,
    unidad: "lata",
    ubicacionFisica: "Góndola M1",
    pesoNeto: "160g",
    proveedor: "Seatech Int.",
    vencimientoMeses: 36,
    descripcionLarga:
      "Atén en lomos en agua 160g. Rico en Omega-3 y proteína magra. Listo para consumir.",
    especificaciones: [
      { clave: "Peso neto", valor: "160g" },
      { clave: "Peso escurrido", valor: "120g" },
    ],
    imageKeywords: ["canned-tuna", "van-camps", "seafood-can"],
    color: "bg-blue-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Sardinas en Tomate",
    marca: "Zenú",
    origen: "Colombia",
    costo: 3200,
    precio: 5500,
    stock: 130,
    stockMinimo: 28,
    stockMaximo: 260,
    unidad: "lata",
    ubicacionFisica: "Góndola M1",
    pesoNeto: "155g",
    proveedor: "Grupo Nutresa",
    vencimientoMeses: 36,
    descripcionLarga:
      "Sardinas en salsa de tomate 155g. Listo servir, económico y nutritivo.",
    especificaciones: [
      { clave: "Peso", valor: "155g" },
      { clave: "Salsa", valor: "Tomate" },
    ],
    imageKeywords: ["canned-sardines", "tomato-sauce", "pantry"],
    color: "bg-red-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Fósforos Caja x10",
    marca: "La Reina",
    origen: "Colombia",
    costo: 2500,
    precio: 4500,
    stock: 150,
    stockMinimo: 30,
    stockMaximo: 300,
    unidad: "paquete",
    ubicacionFisica: "Caja M2",
    proveedor: "Fósforos Nacional",
    descripcionLarga:
      "Pack 10 cajitas de fósforos seguros, 40 palitos cada una. Cabeza de alta ignición.",
    especificaciones: [
      { clave: "Cajitas", valor: "10" },
      { clave: "Palitos/caja", valor: "40" },
    ],
    imageKeywords: ["matches", "matchbox", "pantry-essentials"],
    color: "bg-amber-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Velas Hogareñas x6",
    marca: "Veladoras",
    origen: "Colombia",
    costo: 3500,
    precio: 5900,
    stock: 80,
    stockMinimo: 20,
    stockMaximo: 160,
    unidad: "paquete",
    ubicacionFisica: "Estante M3",
    proveedor: "Cerera Nacional",
    descripcionLarga:
      "Pack 6 velas blancas utilitarias 8hrs duración cada una. Uso emergencias o decoración.",
    especificaciones: [
      { clave: "Unidades", valor: "6" },
      { clave: "Duración", valor: "8h c/u" },
    ],
    imageKeywords: ["candles", "white-candles", "emergency-candles"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Pilas AA Duracell x4",
    marca: "Duracell",
    modelo: "Alkaline AA",
    origen: "EE.UU.",
    costo: 8500,
    precio: 13500,
    stock: 90,
    stockMinimo: 20,
    stockMaximo: 180,
    unidad: "blister",
    ubicacionFisica: "Góndola M4",
    proveedor: "Duracell Colombia",
    vencimientoMeses: 120,
    descripcionLarga:
      "Pack 4 pilas alcalinas AA Duracell Coppertop. Duración garantizada hasta 10 años de almacenamiento.",
    especificaciones: [
      { clave: "Tipo", valor: "AA Alcalina" },
      { clave: "Unidades", valor: "4" },
    ],
    imageKeywords: ["aa-batteries", "duracell", "alkaline-batteries"],
    color: "bg-orange-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Chocolates Jet x24",
    marca: "Jet",
    origen: "Colombia",
    costo: 18500,
    precio: 28900,
    stock: 70,
    stockMinimo: 15,
    stockMaximo: 140,
    unidad: "caja",
    ubicacionFisica: "Góndola M5",
    pesoNeto: "360g",
    proveedor: "Grupo Nutresa",
    vencimientoMeses: 12,
    descripcionLarga:
      "Caja 24 chocolatinas Jet clásicas. álbum del mundo incluido. Ideal para compartir.",
    especificaciones: [
      { clave: "Unidades", valor: "24" },
      { clave: "Peso", valor: "360g" },
    ],
    imageKeywords: ["jet-chocolate", "candy-bar", "sweet-snacks"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Galletas Saltinas 3pkx",
    marca: "Noel",
    modelo: "Saltón Noel",
    origen: "Colombia",
    costo: 6500,
    precio: 10500,
    stock: 100,
    stockMinimo: 22,
    stockMaximo: 200,
    unidad: "paquete",
    ubicacionFisica: "Góndola M5",
    pesoNeto: "300g",
    proveedor: "Grupo Nutresa",
    vencimientoMeses: 9,
    descripcionLarga:
      "Triple pack galletas Saltinas original 300g total. Crocantes, bajas en grasa, ideal con quesos.",
    especificaciones: [
      { clave: "Unidades", valor: "3 tacos" },
      { clave: "Peso total", valor: "300g" },
    ],
    imageKeywords: ["saltine-crackers", "noel-cookies", "crackers"],
    color: "bg-yellow-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Sopa Maggi Costilla",
    marca: "Maggi",
    origen: "Colombia",
    costo: 1500,
    precio: 2500,
    stock: 200,
    stockMinimo: 40,
    stockMaximo: 400,
    unidad: "sobre",
    ubicacionFisica: "Góndola M6",
    pesoNeto: "72g",
    proveedor: "Nestlé Colombia",
    vencimientoMeses: 18,
    descripcionLarga:
      "Sobre sopa instantánea sabor costilla Maggi. Lista en 5 minutos, rinde 2 porciones.",
    especificaciones: [
      { clave: "Peso", valor: "72g" },
      { clave: "Porciones", valor: "2" },
    ],
    imageKeywords: ["instant-soup", "maggi-soup", "pantry"],
    color: "bg-yellow-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Chocolatina Jumbo Maní",
    marca: "Jumbo",
    origen: "Colombia",
    costo: 1200,
    precio: 2000,
    stock: 200,
    stockMinimo: 40,
    stockMaximo: 400,
    unidad: "unidad",
    ubicacionFisica: "Góndola M5",
    pesoNeto: "40g",
    proveedor: "Grupo Nutresa",
    vencimientoMeses: 12,
    descripcionLarga:
      "Chocolatina Jumbo con maní relleno 40g. Snack clásico colombiano.",
    especificaciones: [
      { clave: "Peso", valor: "40g" },
      { clave: "Tipo", valor: "Con maní" },
    ],
    imageKeywords: ["jumbo-chocolate", "peanut-bar", "chocolatina"],
    color: "bg-amber-800",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Gaseosa Postobón 2.5L",
    marca: "Postobón",
    modelo: "Manzana",
    origen: "Colombia",
    costo: 4500,
    precio: 7500,
    stock: 80,
    stockMinimo: 18,
    stockMaximo: 160,
    unidad: "botella",
    ubicacionFisica: "Nevera M7",
    pesoNeto: "2.5L",
    proveedor: "Postobón S.A.",
    vencimientoMeses: 6,
    descripcionLarga:
      "Gaseosa Postobón Manzana familiar 2.5L. Sabor clásico colombiano, rinde 10 vasos.",
    especificaciones: [
      { clave: "Volumen", valor: "2.5L" },
      { clave: "Sabor", valor: "Manzana" },
    ],
    imageKeywords: ["postobon", "apple-soda", "family-soda"],
    color: "bg-red-500",
    shape: "square",
  }),
];
